import { IKWFRoute } from '../../KWFMain';
import { Bind } from '../../navkendo';

import { RwfBootstrap, IFDRW_PurchaseOrder, IFDDI_Wizard_Create_New_DMS_Document, IFDDI_DMS_Purchase_Document, IsRechnungMitBestellbezug, IsPurchOrderChange } from '@common/rwf';
import { NavClientService, NavPageItem } from '@common/navdata';
import { fn } from '@common/utils';
import { CompatibilityService } from '@common/services/compatibilityservice';
import { FDDI_Wizard_Create_New_DMS_Document, FDDI_DMS_Purchase_Document } from '@common/rwf/rwf.const';
import { NavSettingsService } from '@common/services/settingsservice';
import { CtrlPageItemView } from './pageitemview.ctrl';
import { SessionEvents } from '@common/rwf/rwfedit.common';

const FDRW_PurchaseOrder = "FDRW_PurchaseOrder";
const displaychange = SessionEvents.displaychange;
const setPurchOrder = "SetPurchOrder";
const GetPurchTemplate = () => CtrlPageItemView.Template("purchOrder");

/** Purchorder Card View Controller */
export class CtrlPurchOrder extends CtrlPageItemView {
    static RouteName = "purchorder";
    static Route: IKWFRoute = {
        HideBar: true,
        DescriptionFormula: "vm.Title",
        template: GetPurchTemplate,
        controller: CtrlPurchOrder,
        controllerAs: 'vm',
        resolve: {
            "OrderNo": ["$route", ($route: ng.route.IRouteService) => $route.current.params["id"]],
            "extid": ["$route", ($route: ng.route.IRouteService) => $route.current.params["extid"]],
        }
    };

    static Directive = [function (): ng.IDirective {
        return {
            controller: ["$scope", "CompatibilityService", "RwfBootstrap", "NavClient", "NavSettings",
                ($scope, CompatibilityService, RwfBootstrap, NavClient, NavSettings) =>
                    new CtrlPurchOrder($scope, CompatibilityService, RwfBootstrap, NavClient, NavSettings)],
            controllerAs: "vm",
            template: GetPurchTemplate,
            scope: {
                item: "=item"
            },
            link: ($scope, instanceElement, attributes, ctrl) => {
                if (attributes.reference) {
                    $scope.$parent[attributes.reference] = ctrl;
                    $scope.$on("$destroy", () => delete $scope.$parent[attributes.reference]);
                }
            }
        };
    }];

    static $inject = ["$scope", "CompatibilityService", "RwfBootstrap", "NavClient", "NavSettings", "OrderNo", "extid"];
    constructor($scope: ng.IScope,
        $c: CompatibilityService,
        $rwf: RwfBootstrap,
        NavClient: NavClientService,
        NavSettings: NavSettingsService,
        orderNo?: string, extid?: string) {
        super($scope, $c, $rwf, NavClient, NavSettings, extid);

        const ExternalViewProxy = this.ExternalViewProxy;
        if (ExternalViewProxy) {
            ExternalViewProxy.bind(setPurchOrder, e => this.SetPurchOrder(e.OrderNo));
        }
        this.CurrentTitle = 'Bestellung ...';
        // Caution : nav/company must be set: otherwise mutliple creation ...  TODO
        this.GetExternalUrl = (extid) => {
            const NavUrlInfo = this.$rwf.EnsureResolved().NavUrlInfo;
            const Query = fn.EncodeQueryData({ nav: NavUrlInfo.BaseUrl + NavUrlInfo.QueryString, company : NavUrlInfo.Mandant });
            return `./#/${CtrlPurchOrder.RouteName}/${this.CurrItem.Model.No}/${extid}?${Query}`;
        };

        let RegisterDisplayChange = (cb: Function) => Bind(this, cb, displaychange);

        let Rendered = (root: JQuery) => super.onRenderedInDockZone(root);

        $rwf.Resolve.then((rwf) => {
            if (!rwf.RwfSettings.CheckPages.FDRW_PurchaseOrder || rwf.RwfSettings.User.IsStandalone) {
                this.View = null;
                return;
            }

            return NavClient.GetPageClientInfo(FDRW_PurchaseOrder, rwf.NavUrlInfo.FullUrl).then(pageClient => {

                return NavClient.GetView(pageClient).then(view => {
                    if (view && view.Groups.length == 0) {
                        // No Visualization Defined!
                        this.View = null;
                        return;
                    }

                    $scope.$watch(() => $scope["item"], (newVal, oldVal) => {
                        if (!(newVal instanceof NavPageItem)) {
                            if (oldVal) {
                                this.BindToMasterPageItem(undefined);
                            }
                            return;
                        }
                        this.BindToMasterPageItem(newVal);
                    });

                    $scope.$on("$destroy", () => {
                        this.BindToMasterPageItem(undefined);
                        RegisterDisplayChange = fn.ToFunc(fn.noop);
                        Rendered = fn.noop;
                        this.unbind(undefined, null);
                    });
                    view.UserPersistToken = ["KWF", "ViewConfiguration", FDRW_PurchaseOrder];

                    if (orderNo) {
                        this.SetPurchOrder(orderNo);
                    }

                    this.ZonesOptions = {
                        DockOptions: undefined,
                        Register: RegisterDisplayChange,
                        Rendered: Rendered,
                        View: view,
                        Item: this.CurrItem
                    };
                    return this.View = view;
                });
            }).then(undefined, err => this.Error = fn.resolveToError(err));
        });
    }

    public readonly PageName = FDRW_PurchaseOrder;

    /** Sync Order No from wizard */
    public BindToMasterPageItem(item: NavPageItem) {
        const SetMaster = "SetMaster";
        this.trigger(SetMaster);

        let prop = "";
        let prop2: string;
        switch (item && item.PageName) {
            case FDDI_Wizard_Create_New_DMS_Document:
                prop2 = "Creation_Type"
                prop = <keyof IFDDI_Wizard_Create_New_DMS_Document>"Order_No";
                break;

            case FDDI_DMS_Purchase_Document:
                prop2 = "Document_Type"
                prop = <keyof IFDDI_DMS_Purchase_Document>"OrderNo";
                break;
            default:
                // ??
        }

        if (prop && item) {
            let refresh = () => this.SetPurchOrder((IsRechnungMitBestellbezug(item) || IsPurchOrderChange(item)) && item.GetValue(prop));
            this.one(SetMaster, item.RegisterPropertyChanged(prop, () => refresh()));
            if(prop2) {
                this.one(SetMaster, item.RegisterPropertyChanged(prop2, () => refresh()));
            }
            refresh();
        } else {
            this.SetPurchOrder(undefined);
        }
    }

    /** Load Purch Order by No */
    public SetPurchOrder(strNo: string) {

        // Dispatch to external proxy if active
        const _externalView = this._externalView;
        if (_externalView && _externalView.Alive) {
            const proxy = _externalView.getUndocked();
            if (proxy)
                proxy.trigger(setPurchOrder, { OrderNo: strNo });
        }

        // check for already loaded (..ing)
        if (strNo) {
            const CurrItem = this.CurrItem;
            if (CurrItem && CurrItem.Model.No === strNo) {
                return this.$c.when(CurrItem);
            }

            const currRead = this._currRead;
            if (currRead && currRead.No === strNo) {
                return currRead.then(() => this.CurrItem);
            }
        }

        const reset = () => {
            if (result == this._currRead) {
                delete this._currRead;
            }
        };

        if (!strNo) {
            loadItem = this.$c.when(undefined);
            this.Error = "";
            this.Show = false;
        } else {
            this.Show = true;
            this.CurrentTitle = `Bestellung ${strNo} wird geladen!`;

            var loadItem = this.NavClient.LoadItem<IFDRW_PurchaseOrder>({
                Keys: { No: strNo },
                NavUrl: this.$rwf.EnsureResolved().NavUrlInfo.FullUrl,
                PageName: FDRW_PurchaseOrder
            }).then(item => {
                if (item) {
                    // we don't want to edit!
                    item.Anchor.Readonly.SetForceAll(true);
                }
                return item;
            });
        }

        const result = this._currRead = loadItem.then(item => {
            if (result == this._currRead) {
                this.Error = "";
                this._currItem = item;
                const orderNo = this.OrderNo = item && item.Model.No;
                this.CurrentTitle = "Bestellung " + (orderNo || (` "${strNo}" nicht gefunden!`));
                if (!orderNo) {
                    if (!strNo) {
                        this.Error = this.CurrentTitle = `Keine BestellNr angegeben`;
                    } else {
                        this.Error = this.CurrentTitle = `Bestellung '${strNo}' konnte nicht gefunden werden!`;
                    }
                }

                // Trigger displayChange : Properties must match INavPageItemEditorOptions
                const ZonesOptions = this.ZonesOptions;
                if (ZonesOptions) {
                    ZonesOptions.Item = item;
                }
                this.trigger(displaychange, ZonesOptions);
            }
            return item;
        }, err => {
            if (result == this._currRead) {
                this.Error = fn.resolveToError(err);
            }
            throw err;
        });

        this._currRead.No = strNo;
        result.then(reset, reset);
        return result;
    }
    private _currRead: PromiseLike<NavPageItem<IFDRW_PurchaseOrder>> & { No?: string };

    public get Loading() {
        return !!this._currRead;
    }

    public get CurrItem() {
        return this._currItem;
    }
    private _currItem: NavPageItem<IFDRW_PurchaseOrder>;

    public OrderNo: string;
}
